<template>
  <custom-dialog :visible="visible" width="600px" class="part-life-dialog" :title="model.title" v-on="$listeners">
    <div class="dialog-body">
      <div class="msg-content">
        <div class="title">{{ $t('asm_part_life_dialog.ljjbxx') }}</div>
        <ul class="msg-list">
          <li>
            <div class="key">{{ $t('asm_part_life_dialog.ling_jian_bian_hao') }}</div>
            <div class="val">{{ model.data.partCode || '-' }}</div>
          </li>
          <li>
            <div class="key">{{ $t('asm_part_life_dialog.ling_jian_lei_xing') }}</div>
            <div class="val">{{ getDicValue('asm_part_type',model.data.partType)  || '-'}}</div>
          </li>
          <li>
            <div class="key">{{ $t('asm_part_life_dialog.ling_jian_ming_cheng') }}</div>
            <div class="val">{{ model.data.partName || '-'}}</div>
          </li>
          <li>
            <div class="key">{{ $t('asm_part_life_dialog.ling_jian_dan_wei') }}</div>
            <div class="val">{{ getDicValue('after_sale_unit',model.data.partUnit)|| '-'}}</div>
          </li>
          <li>
            <div class="key">{{ $t('asm_part_life_dialog.pjsysmH') }}</div>
            <div class="val">{{ model.data.averageUseTime || '-'}}</div>
          </li>
          <li>
            <div class="key">{{ $t('asm_part_life_dialog.zcsysmH') }}</div>
            <div class="val">{{ model.data.maxUseTime || '-'}}</div>
          </li>
          <li>
            <div class="key">{{ $t('asm_part_life_dialog.zdsysmH') }}</div>
            <div class="val">{{ model.data.minUseTime || '-'}}</div>
          </li>
        </ul>
      </div>
      <div class="input-container">
        <el-form :model="form" :rules="rules" ref="form">
          <el-form-item :label="$t('asm_part_life_dialog.li_lun_shou_mingH')" prop="theoryUseTime" :rules="rules.theoryUseTime">
            <el-input type="number" v-model="form.theoryUseTime" style="width: 100%"></el-input>
          </el-form-item>

        </el-form>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">{{ $t('Common.com_close') }}</el-button>
      <el-button type="primary" @click="onSave">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import apis from '@/utils/apis';
import dialogMixins from '@/mixins/dialog_mixins.js';

export default {
  mixins: [dialogMixins],
  data() {
    return {
      form: {
        theoryUseTime: ''
      },
    };
  },
  mounted: function () {
    this.initDialog();
    this.form.theoryUseTime = this.model.data.theoryUseTime;
  },

  computed: {
    rules() {
      return {
        theoryUseTime: {
          required: true,
          message: this.$t('asm_part_life_dialog.qsrllsm')
        },

      };
    },
  },
  methods: {
    // 初始化
    initDialog: function () {
      this.$nextTick(() => {
        this.visible = true;
      });
    },
    onSave() {
      this.$refs.form.validate((val) => {
        if (val) {
          this.form.partId = this.model.data.partId;
          this.$postJSON(apis.PartLifeSet, this.form).then(() => {
            this.$message({
              message: this.$t('Common.com_modify_success'),
              type: 'success'
            });
            this.$emit('success');
            this.visible = false;
          });
        }
      });
    }
  }
};
</script>

<style lang="scss">
.part-life-dialog {
  .el-form-item__label {
    width: 100%;
    text-align: left;
  }

  .dialog-body {
    width: 100%;
    padding: 0 !important;
    display: flex;
    .msg-content {
      width: 300px;
      padding: 0 24px 40px;
      height: 100%;
      background: #f8f9fb;
      .title {
        $h: 60px;
        height: $h;
        line-height: $h;
        color: #495057;
        font-weight: bold;
        font-size: 14px;
      }
      .msg-list {
        > li {
          overflow: hidden;
          padding-top: 9px;
          padding-bottom: 10px;
          color: #6c757d;
          font-size: 12px;
          line-height: 17px;
          border-bottom: 1px solid #eef2f7;
          .key {
            float: left;
            width: 50%;
          }
          .val {
            float: left;
            text-align: right;
            width: 50%;
          }
        }
      }
    }
    .input-container {
      flex: 1;
      padding: 24px 24px 0 24px;
      background: #fff;
    }
  }
}
</style>
